import { Avatar } from '@billda/design-system';
import { GangRoleBadge } from '../atoms/GangRoleBadge';

interface GangMemberHeaderProps {
  fullName: string;
  email: string;
  role: 'leader' | 'member';
}

const getInitials = (name: string) => {
  if (!name) {
    return 'U';
  }
  return (
    name
      .split(' ')
      .filter(Boolean)
      .map(part => part[0]?.toUpperCase() ?? '')
      .join('')
      .slice(0, 2) || 'U'
  );
};

export const GangMemberHeader = ({
  fullName,
  email,
  role,
}: GangMemberHeaderProps) => {
  const displayEmail = email?.trim() || 'Email unavailable';

  return (
    <div className="mb-4 flex items-center">
      <Avatar
        aria-label={fullName}
        className={`mr-4 text-on-primary ${
          role === 'leader'
            ? 'bg-surface-primary'
            : 'bg-surface-inverse text-on-inverse'
        }`}
      >
        {getInitials(fullName)}
      </Avatar>
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="type-body-lg font-medium">{fullName}</span>
          <GangRoleBadge role={role} />
        </div>
        <p className="type-body-md text-content-secondary">{displayEmail}</p>
      </div>
    </div>
  );
};
